"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _this = void 0; // eslint-disable-next-line @typescript-eslint/no-empty-function


var noop = function noop() {
  (0, _newArrowCheck2.default)(this, _this);
}.bind(void 0);

var _default = noop;
exports.default = _default;